export class GetAccountStateError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'GetAccountOnPushService';
        this.stack = stack;
        Object.setPrototypeOf(this, GetAccountStateError.prototype);
    }
}
